// @flow

export type SET_MAP_POSITION_TYPE = {
  type: 'SET_MAP_POSITION',
  payload: {
    zoom: number,
    longitude: number,
    latitude: number,
    animate: boolean
  }
};
export const SET_MAP_POSITION = 'SET_MAP_POSITION';

export type MAP_PRISTINE_SET_TYPE = {
  type: 'MAP_PRISTINE_SET',
};
export const MAP_PRISTINE_SET = 'MAP_PRISTINE_SET';

export type MAP_DIRTY_SET_TYPE = {
  type: 'MAP_DIRTY_SET',
};
export const MAP_DIRTY_SET = 'MAP_DIRTY_SET';

export type MAP_SET_LOADING_TYPE = {
  type: 'MAP_SET_LOADING',
  payload: string, // Message
};
export const MAP_SET_LOADING = 'MAP_SET_LOADING';

export type MAP_COMPLETED_LOADING_TYPE = {
  type: 'MAP_COMPLETED_LOADING',
};
export const MAP_COMPLETED_LOADING = 'MAP_COMPLETED_LOADING';

export type MAP_ACTION_TYPE =
  SET_MAP_POSITION_TYPE |
  MAP_PRISTINE_SET_TYPE |
  MAP_DIRTY_SET_TYPE |
  MAP_SET_LOADING_TYPE |
  MAP_COMPLETED_LOADING_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/map.js